import { render, staticRenderFns } from "./CathayPropertyNewInsurance.vue?vue&type=template&id=4d263749"
import script from "./CathayPropertyNewInsurance.vue?vue&type=script&lang=js"
export * from "./CathayPropertyNewInsurance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports